import { Nav } from 'react-bootstrap';
import styled from 'styled-components';

export const NavBarStyled = styled(Nav)`
  justify-content: center;
  border-bottom: 1px solid #eeeeee;
  background-color: #ffffff;

  a {
    font-size: 1.1rem;
    margin: 0 2rem;
    color: #444;
  }
  .nav-link.active {
    background-color: #f5faff;
    border: none;
    border-bottom: 0.2rem solid #0f8dff;
  }
  #side_nav_icon {
    position: absolute;
    left: 1rem;
  }
`;

export const SideBarContainer = styled('div')<{ isOpen: boolean }>`
  display: flex;
  position: relative;
  transition: width 0.2s ease;
  border-right: 1px solid #eeeeee;
  border-radius: 4px;
  #button_container {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding-right: 0.3rem;
    padding-top: 0.3rem;
  }
  #side_nav_icon {
    background-color: white;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
  }
`;
